import { WELCOME_CHIPS } from '../sample-questions'

type WelcomeProps = {
  onSelectChip: (text: string) => void
}

export const Welcome = ({ onSelectChip }: WelcomeProps) => {
  return (
    <div className="flex h-full flex-col items-center justify-center px-6 py-10 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#2563eb] to-[#7c3aed] text-3xl text-white shadow-md">
        ✨
      </div>
      <h2 className="mb-2 text-xl font-extrabold text-slate-900">How can I help you today?</h2>
      <p className="mb-6 max-w-md text-sm text-slate-500">
        Ask BeAssistant anything about patients, appointments, billing, or operations. Try one of
        these to get started.
      </p>
      <div className="flex w-full flex-wrap items-center justify-center gap-2">
        {WELCOME_CHIPS.map((chip) => (
          <button
            key={chip}
            type="button"
            onClick={() => onSelectChip(chip)}
            className="rounded-full border border-[#e2e8f0] bg-white px-3.5 py-2 text-xs text-slate-700 shadow-sm transition hover:border-[#bfdbfe] hover:bg-[#eff6ff] hover:text-[#2563eb]"
          >
            {chip}
          </button>
        ))}
      </div>
    </div>
  )
}
